<div class="flex-column f-1-0">
	<ng-container *ngFor="let condition of conditionArr; let first = first; let orIndex = index">
		<span class="fw-bold opacity-75" style="color: #486db5; margin: 8px 5px;" *ngIf="!first">OR</span>
		<ng-container *ngTemplateOutlet="conditionHtml; context: {$implicit: condition, orIndex}"></ng-container>
	</ng-container>
</div>

<ng-template #conditionHtml let-condition let-orIndex="orIndex">
	<div class="flex-row gap-4 align-items-center f-1-0">

		<!--Select condition type-->
		<app-dropdown-c style="width: 180px; --dropdown-menu-width: 800px;" (click)="clearSearchCondition();"
						[isDisabled]="condition.type === rulesOptions.types.keywords.name && condition._id && condition.data && condition.data.file"
						text="{{rulesOptions.types[condition.type].label}}">
			<ul style="overflow: auto; min-height: 110px;">
				<li class="static-item" style="min-height: 0;" (click)="$event.stopPropagation()">
					<div class="search-box flxRow" style="position: relative; max-width: 300px;">
						<input type="search" class="w-100"
							   [(ngModel)]="searchConditionText"
							   maxlength="{{dic.CONSTANTS.maxCharsInSearch}}"
							   (keyup)="searchCondition(searchConditionText);"
							   placeholder="Search condition">
						<a class="closeRed animated fadeIn"
						   id="clearSearchCondition"
						   (click)="clearSearchCondition();"
						   *ngIf="searchConditionText"
						   style="font-size: 16px; color: #cccccc; position: absolute; right: 15px; top: calc(50% + 1px); transform: translateY(-50%);">
							<i class="zmdi zmdi-close"></i>
						</a>
					</div>
				</li>
				<div class="flex-row flex-wrap overflow-auto" style="max-height: 40vh;">
					<li *ngFor="let item of rulesOptions.types | keyvalue: gs.returnZero"
						class="flex-column w-50" style="gap: 3px;"
						[hidden]="rulesOptions.types[item.key].hide"
						(click)="changeConditionType(condition, item.key)">
						<span class="fw-500" style="font-size: 14px;">{{rulesOptions.types[item.key].label}}</span>
						<i style="color: #505050; font-size: 12px;">{{rulesOptions.types[item.key].tooltip}}</i>
					</li>
					<li *ngIf="searchResultNotFound" class="d-flex centralize py-3" (click)="$event.stopPropagation()">
						No items found
					</li>
				</div>
			</ul>
		</app-dropdown-c>

		<ng-container>
			<span class="text-nowrap">detected in</span>

			<!--Select condition subtype (single)-->
			<div *ngIf="condition.singleSubType">
				<app-dropdown-c class="animated fadeIn" style="width: 150px;"
								*ngIf="condition.subType[0] !== dic.CONSTANTS.inboundEmailRule.subTypes.freeText"
								text="{{condition.subType[0]}}"></app-dropdown-c>
				<input type="text" class="lowerPlaceholder" maxlength="100"
					   style="width: 150px;"
					   *ngIf="condition.subType[0] === dic.CONSTANTS.inboundEmailRule.subTypes.freeText"
					   placeholder="{{condition.placeholder}}"
					   [(ngModel)]="condition.values.key"
					   (ngModelChange)="isConditionDataChanged(condition);"
					   [ngClass]="condition.invalidHeaderKey && 'validation-error'"/>
			</div>
			<!--Select condition subtype (multiple)-->
			<div *ngIf="!condition.singleSubType"
				 [ngStyle]="{'text-transform' : condition.type === dic.CONSTANTS.inboundEmailRule.types.auth_headers.name && condition?.subTypeShow?.length ? 'uppercase' : ''}">
				<app-dropdown-c style="width: 150px;" id="{{'rulesPoliciesDropdownSubType' + conditionIndex}}"
								[error]="condition.invalidSubTypes"
								[text]="condition?.subTypeShow?.join(', ') || 'Choose'">
					<ul>
						<li *ngFor="let item of dic.CONSTANTS.inboundEmailRule.types[condition.type].subTypes| keyvalue: gs.returnZero"
							[explanationC]="condition.type === dic.CONSTANTS.inboundEmailRule.types.keywords.name ? item.key === 'body' ? 'Email body - including file names' : 'Email subject' : ''"
							(click)="condition.subType[item.key] = !condition.subType[item.key]; subtypeChanged(condition); $event.stopPropagation();"
							id="{{'rulesPoliciesSubTypeValue' + item.key + conditionIndex}}">
							<checkbox (click)="$event.preventDefault();"
									  [ngStyle]="{'text-transform' : condition.type === dic.CONSTANTS.inboundEmailRule.types.auth_headers.name ? 'uppercase' : ''}"
									  [(model)]="condition.subType[item.key]">
								{{item.key}}
							</checkbox>
						</li>
					</ul>
				</app-dropdown-c>
			</div>
		</ng-container>

		<!--connection word(s)-->
		<a class="flex-row text-nowrap blue-link text-decoration-underline"
		   [ngClass]="{'text-danger' : condition.is_negate}"
		   (click)="condition.is_negate = !condition.is_negate;">
			<span>{{dic.CONSTANTS.inboundEmailRule.types[condition.type].isPlural ? 'are' : 'is'}}</span>
			<span class="fw-500" *ngIf="condition.is_negate">&nbsp;NOT</span>
		</a>

		<!--match type dropdown-->
		<app-dropdown-c *ngIf="condition.type === dic.CONSTANTS.inboundEmailRule?.types?.addresses?.name || condition.type === dic.CONSTANTS.inboundEmailRule?.types?.sender?.name || condition.type === dic.CONSTANTS.inboundEmailRule?.types?.keywords?.name ||
							   condition.type === dic.CONSTANTS.inboundEmailRule?.types?.domains?.name || condition.type === dic.CONSTANTS.inboundEmailRule?.types?.email_header?.name ||
							   condition.type === dic.CONSTANTS.inboundEmailRule?.types?.email_scan_status?.name || condition.type === dic.CONSTANTS.inboundEmailRule?.types?.names?.name ||
							   condition.type === dic.CONSTANTS.inboundEmailRule?.types?.sensitivity_type?.name"
						style="width: 190px;"
						(click)="showMatchActions(condition);"
						text="{{condition?.data?.matchType}}">
			<ul>
				<li *ngFor="let matchTypeVal of condition.actions"
					(click)="changeMatchType(matchTypeVal, condition);">
					<span [explanationC]="dic.CONSTANTS.ruleMatchTypeTooltip[matchTypeVal]">
						{{matchTypeVal}}
					</span>
				</li>
			</ul>
		</app-dropdown-c>
		<!----><!---->

		<ng-container *ngIf="condition.type === dic.CONSTANTS.inboundEmailRule?.types?.sensitivity_type?.name && condition.data?.matchType === dic.CONSTANTS.ruleMatchType.moreThan">
			<div class="flex-row align-items-center gap-1 text-nowrap">
				<input type="number" style="width: 45px; margin: 0 2px;" min="1" max="10"
					   [(ngModel)]="condition.data.matchCount">
				<span>times</span>
			</div>
		</ng-container>

		<!--select values-->
		<ng-container [ngSwitch]="condition.type">

			<!--keywords-->
			<app-dropdown-c *ngIf="condition.type === dic.CONSTANTS.inboundEmailRule.types.keywords.name && (condition?.data?.matchType === dic.CONSTANTS.ruleMatchType.exactMatch || condition?.data?.matchType === dic.CONSTANTS.ruleMatchType.contains)"
							style="width: 200px;" [ngStyle]="{'color' : condition?.data?.keywords?.length ? '' : 'darkgrey', 'font-size': condition?.data?.keywords?.length ? '' : '11.4px'}"
							(click)="showPopup(condition);" tooltip="Click to view and edit"
							[isDisabled]="condition.type === dic.CONSTANTS.inboundEmailRule.types.keywords.name && condition?._id && condition?.data && condition?.data?.file"
							text="{{condition?.data?.keywords?.join(' , ') || 'Click to add Keywords'}}"
							[renderAsPlainText]="true"
							[error]="condition?.invalidKeywords">
			</app-dropdown-c>

			<!--addresses-->
			<app-dropdown-c *ngIf="(condition.type === dic.CONSTANTS.inboundEmailRule.types.addresses.name || condition.type === dic.CONSTANTS.inboundEmailRule.types.sender.name) &&
								   [dic.CONSTANTS.ruleMatchType.exactMatch, dic.CONSTANTS.ruleMatchType.startsWith, dic.CONSTANTS.ruleMatchType.endsWith, dic.CONSTANTS.ruleMatchType.belongsTo, dic.CONSTANTS.ruleMatchType.contains].indexOf(condition?.data?.matchType) > -1"
							style="width: 200px;" tooltip="Click to view and edit"
							[ngStyle]="{'color' : (condition?.data?.matchType !== dic.CONSTANTS.ruleMatchType.belongsTo && condition?.data?.emails?.length) || (condition?.data?.matchType === dic.CONSTANTS.ruleMatchType.belongsTo && getDataGroupsNames(condition).length) ? '' : 'darkgrey',
											 'font-size': (condition?.data?.matchType !== dic.CONSTANTS.ruleMatchType.belongsTo && condition?.data?.emails?.length) || (condition?.data?.matchType === dic.CONSTANTS.ruleMatchType.belongsTo && getDataGroupsNames(condition).length) ? '' : '11.4px'}"
							(click)="condition.data.matchType !== dic.CONSTANTS.ruleMatchType.belongsTo ? showPopup(condition) : openGroupsPopup(true, condition)"
							text="{{condition?.data?.matchType !== dic.CONSTANTS.ruleMatchType.belongsTo ? (condition?.data?.emails?.join(' , ') || 'Click to add email addresses') : (getDataGroupsNames(condition).join(', ') || 'Click to select groups')}}"
							[error]="condition.invalidEmails"></app-dropdown-c>

			<!--names-->
			<app-dropdown-c *ngIf="condition.type === dic.CONSTANTS.inboundEmailRule.types.names.name &&
								   [dic.CONSTANTS.ruleMatchType.exactMatch, dic.CONSTANTS.ruleMatchType.startsWith, dic.CONSTANTS.ruleMatchType.endsWith, dic.CONSTANTS.ruleMatchType.contains].indexOf(condition?.data?.matchType) > -1"
							style="width: 200px;" tooltip="Click to view and edit"
							[ngStyle]="{'color' : condition?.data?.names?.length ? '' : 'darkgrey', 'font-size': condition?.data?.names?.length ? '' : '11.4px'}"
							(click)="showPopup(condition);"
							text="{{condition?.data?.names?.join(' , ') || 'Click to add name'}}"
							[renderAsPlainText]="true"
							[error]="condition.invalidNames"></app-dropdown-c>

			<!--domains-->
			<app-dropdown-c *ngIf="condition.type === dic.CONSTANTS.inboundEmailRule.types.domains.name && condition.data.matchType === dic.CONSTANTS.ruleMatchType.exactMatch"
							style="width: 200px;" [ngStyle]="{'color' : condition?.data?.domains?.length ? '' : 'darkgrey', 'font-size': condition?.data?.domains?.length ? '' : '11.4px'}"
							(click)="showPopup(condition);" tooltip="Click to view and edit"
							text="{{condition?.data?.domains?.length ? condition?.data?.domains?.join(', ') : 'Click to add domains'}}"
							[error]="condition.invalidDomains"></app-dropdown-c>

			<!--email header-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.email_header.name"
							style="width: 200px;" [ngStyle]="{'color' : condition?.values?.value?.length ? '' : 'darkgrey', 'font-size': condition?.values?.value?.length ? '' : '11.4px'}"
							(click)="showPopup(condition);" tooltip="Click to view and edit"
							text="{{condition?.values?.value?.length ? condition?.values?.value?.join(', ') : 'Click to add header values'}}"
							[renderAsPlainText]="true"
							[error]="condition?.invalidHeaderValue">
			</app-dropdown-c>

			<!--sender country TLD types-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.sender_country_tld.name"
							style="width: 200px;" [ngStyle]="{'color' : condition?.data?.tld?.length ? '' : 'darkgrey', 'font-size': condition?.data?.tld?.length ? '' : '11.4px'}"
							(click)="showSenderCountryTldPopup(condition);" tooltip="Click to view and edit"
							text="{{condition?.data?.tld?.length ? condition?.data?.tld?.join(', ') : 'Click to add sender country TLD'}}"
							[error]="condition?.invalidSenderCountryTld">
			</app-dropdown-c>

			<!--email language-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.email_language.name"
							style="width: 200px;" [ngStyle]="{'color' : condition?.data?.languages?.length ? '' : 'darkgrey', 'font-size': condition?.data?.languages?.length ? '' : '11.4px'}"
							(click)="showEmailLanguagePopup(condition);" tooltip="Click to view and edit"
							text="{{condition?.data?.languages?.length ? getEmailLanguagesNames(condition).join(', ') : 'Click to add languages'}}"
							[error]="condition?.invalidEmailLanguage">
			</app-dropdown-c>

			<!--attachment types-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.attachment_types.name"
							style="width: 200px;" [ngStyle]="{'color' : condition?.data?.attachment_types?.length ? '' : 'darkgrey', 'font-size': condition?.data?.attachment_types?.length ? '' : '11.4px'}"
							(click)="showAttachmentTypesPopup(condition);" tooltip="Click to view and edit"
							text="{{condition?.data?.all_types ? 'any type' : condition?.data?.attachment_types?.length ? condition?.data?.typesDisplay : 'Click to add attachment types'}}"
							[error]="condition?.invalidAttachmentsTypes">
			</app-dropdown-c>

			<!--email_scan_sub_status-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.email_scan_sub_status.name"
							style="width: 200px;" [ngStyle]="{'color' : condition?.data?.tpMetrics?.length ? '' : 'darkgrey', 'font-size': condition?.data?.tpMetrics?.length ? '' : '11.4px'}"
							(click)="showEmailSubStatusScanPopup(condition);" tooltip="Click to view and edit"
							text="{{condition?.data?.tpMetrics?.length ? condition?.data?.tpMetrics.join(', ') : 'Click to add sub category'}}"
							[error]="condition?.invalidScanSubStatusTypes">
			</app-dropdown-c>

			<!--groups-->
			<a *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.groups.name"
			   class="blue-link"
			   (click)="openGroupsPopup(true, condition)"
			   [ngClass]="{'validation-error': condition.invalidGroups}">
				{{condition.data?.groups && condition.data.groups.length ? condition.data.groups.length + ' groups selected (click to edit)' : 'Select groups'}}
			</a>

			<!--sensitivity_type-->
			<a *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.sensitivity_type?.name"
			   class="blue-link text-center" style="word-break: keep-all;"
			   (click)="openSensitivityTypesPopup(condition)"
			   [tooltip]="condition?.data?.sensitivity_types && condition?.data?.sensitivity_types?.length ? condition?.data?.sensitivity_types?.join(', ') : ''"
			   [ngClass]="{'validation-error': condition.invalidSensitivityType}">
				<ng-container *ngIf="condition.data.sensitivity_types?.length">
					{{condition.data.sensitivity_types.length}} types selected <span class="text-nowrap">(click to edit)</span>
				</ng-container>
				<ng-container *ngIf="!condition.data.sensitivity_types?.length">
					Select sensitivity types
				</ng-container>
			</a>

			<!--email_size-->
			<div *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.email_size.name" class="flxRow gap-2" style="align-items: center;">
				<span>bigger than</span>
				<input *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.email_size.name" type="number"
					   placeholder="size" max="65535" min="1"
					   [(ngModel)]="condition.data.size"> KB
			</div>

			<!--received_time-->
			<div *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.received_time.name" class="flxRow gap-3" style="align-items: center;">
				<span>between</span>
				<app-dropdown-c style="width: 120px; --bs-dropdown-max-height: 210px; --bs-dropdown-overflow: auto;"
								[error]="condition.invalidReceivedTime && (!condition.data.received_time_start || _.toNumber(condition.data.received_time_start) > _.toNumber(condition.data.received_time_end || 24))"
								[text]="condition.data.received_time_start">
					<li *ngFor="let hour of hours"
						(click)="condition.data.received_time_start = hour; condition.invalidReceivedTime = false;"
						id="fromHour_{{hour}}">
						{{hour}}
					</li>
				</app-dropdown-c>
				<span>and</span>
				<app-dropdown-c style="width: 120px; --bs-dropdown-max-height: 210px; --bs-dropdown-overflow: auto;"
								[error]="condition.invalidReceivedTime && (!condition.data.received_time_end || _.toNumber(condition.data.received_time_start || 0) > _.toNumber(condition.data.received_time_end))"
								[text]="condition.data.received_time_end">
					<li *ngFor="let hour of hours"
						(click)="condition.data.received_time_end = hour; condition.invalidReceivedTime = false;"
						id="fromHour_{{hour}}">
						{{hour}}
					</li>
				</app-dropdown-c>
			</div>

			<!--received_day-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.received_day.name"
							style="width: 200px;"
							[items]="condition.data.received_day"
							(onItemClicked)="condition.invalidReceivedDay = false;"
							[isMultipleSelection]="true"
							itemDisplayKey="name"
							[error]="condition?.invalidReceivedDay">
			</app-dropdown-c>

			<!--auth_headers-->
			<app-dropdown-c *ngSwitchCase="dic.CONSTANTS.inboundEmailRule.types.auth_headers.name"
							style="width: 200px;"
							[items]="condition.data.statuses"
							(onItemClicked)="condition.invalidStatus = false;"
							[isMultipleSelection]="true"
							itemDisplayKey="name"
							[error]="condition?.invalidStatus">
			</app-dropdown-c>

			<!--regex-->
			<div *ngIf="(condition.type === dic.CONSTANTS.inboundEmailRule.types.keywords.name || condition.type === dic.CONSTANTS.inboundEmailRule.types.addresses.name || condition.type === dic.CONSTANTS.inboundEmailRule.types.sender.name) && condition?.data?.matchType === dic.CONSTANTS.ruleMatchType.regex"
					class="flex-row gap-1 justify-content-center align-items-center">
				<span>/</span>
				<input type="text" maxlength="500" style="width: 150px;"
					   placeholder="Regex (JavaScript)"
					   [(ngModel)]="condition.data.regex"/>
				<span>/</span>
				<input type="text" style="width: 60px;"
					   placeholder="Flags"
					   [(ngModel)]="condition.data.regex_flags"/>
			</div>
		</ng-container>

		<i class="zmdi zmdi-close text-danger hvr-darken cursor-pointer px-3 py-2 animated fadeIn" tooltip="Remove condition"
		   *ngIf="(condition.isException ? true : newRule.conditions.length > 1) || conditionArr.length > 1"
		   (click)="cancelNewRuleCondition(orIndex, conditionIndex)"></i>
	</div>
</ng-template>

<!--condition values popup-->
<popup-c *ngIf="valuesPopup?.show" style="display: contents;"
		 head="Add or edit {{valuesPopup.name}}"
		 width="800px" height="650px"
		 [subTitle]="valuesPopup.subtitle"
		 (closeCb)="valuesPopup.show = false"
		 (confirmCb)="applyPopupCondition(conditionInEdit)"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}" size="medium">
	<div class="flex-column f-1-0 vSpace2 add-action-and-list" style="overflow: auto;">
		<form novalidate style="z-index: 15;">
			<div class="add-single-item flxRow gap-2">
				<input class="emailType" style="margin: 0; width: 90%;" required
					   [(ngModel)]="valuesPopup.input"
					   [ngModelOptions]="{standalone: true}"
					   (ngModelChange)="isValueChanged(conditionInEdit);"
					   type="text"
					   placeholder="{{valuesPopup.placeholder}}"
					   (keypress)="handleKeypress($event, conditionInEdit)"
					   [ngClass]="{'disabled': conditionInEdit.type === dic.CONSTANTS.inboundEmailRule.types.keywords.name && conditionInEdit._id && conditionInEdit.data && conditionInEdit.data.file}"
				/>
				<div [style.width]="(conditionInEdit.type === dic.CONSTANTS.inboundEmailRule.types.addresses.name || conditionInEdit.type === dic.CONSTANTS.inboundEmailRule.types.sender.name) ? '200px' : ''"
					 [ngClass]="{'btn-with-dropdown' : (conditionInEdit.type === dic.CONSTANTS.inboundEmailRule.types.addresses.name || conditionInEdit.type === dic.CONSTANTS.inboundEmailRule.types.sender.name)}">
					<btn-c [isDisabled]="!valuesPopup.input || conditionInEdit.invalidInput"
						   [loading]="openUsersSelectionPopupInProcess"
						   (action)="isValueAddedToList(conditionInEdit);">
						Add
					</btn-c>
					<app-dropdown-c [isLf]="true" *ngIf="(conditionInEdit.type === dic.CONSTANTS.inboundEmailRule.types.addresses.name || conditionInEdit.type === dic.CONSTANTS.inboundEmailRule.types.sender.name)">
						<li (click)="openUsersSelection();">
							Add from my mailboxes
						</li>
					</app-dropdown-c>
				</div>
			</div>
		</form>
		<div class="listTable alternated flxClmn f-1-0" style="z-index: 10;">
			<table>
				<thead>
				<tr>
					<th>
						{{ valuesPopup.name.slice(0, -1) }}
					</th>
					<th style="width:50px;">
					</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let record of valuesPopup.currentList">
					<td>
						<div class="name ellipsis">
							<div class="name ellipsis">
								<div tooltip="{{record}}" placement="top">
									{{record}}
								</div>
							</div>
						</div>
					</td>
					<td>
						<a (click)="isValueRemoved(conditionInEdit, record)" class="opener closeRed" style="padding-left: 10px;">
								<span style="padding: 0;">
									<i class="zmdi zmdi-close" style="position: relative;"></i>
								</span>
						</a>
					</td>
				</tr>
				</tbody>
			</table>
			<!-- placeholder for empty table: -->
			<div class="w100 flxClmn-center" style="flex:1 0; text-align: center; color: darkgrey;"
				 *ngIf="!valuesPopup.currentList?.length">
				<span>No {{conditionInEdit?.data?.matchType === dic.CONSTANTS.ruleMatchType.exactMatch ? valuesPopup.name : "values"}} in list</span>
			</div>
			<!-- end -->
		</div>
		<div class="flxRow-start hSpace1 list-csv-action">
			<a style="margin: 0 8px 0 0; padding : 0;" class="hSpace05" (mouseover)="mouseOverAttachment = true;"
			   ngfDrop
			   ngfSelect
			   [(file)]="valuesPopup.file"
			   (fileChange)="importConditionListFromCsv(valuesPopup.file,conditionInEdit)"
			   [(validDrag)]="validDrag"
			   [(invalidDrag)]="invalidDrag"
			   [ngClass]="{'drag-and-drop-hover': validDrag, 'dragOverClassObj': validDrag, 'hover': mouseOverAttachment}"
			   accept='.csv'
			>
				<i class="far fa-file-import"></i>
				<span class="action-name" tooltip='A column named "{{valuesPopup.name.slice(0,-1)}}" should contain the values'>Import from CSV</span>
			</a>
			<a class="hSpace05" style="margin: 0 0 0 8px; padding : 0;"
			   (click)="exportConditionListToCsv(conditionInEdit)"
			   [ngClass]="{'disabled': !valuesPopup.currentList.length}">
				<i class="far fa-file-export"></i>
				<span class="action-name">Export to CSV</span>
			</a>
		</div>
	</div>
</popup-c>

<!--attachment type popup-->
<popup-c *ngIf="attachmentTypesPopup?.show"
		 head="Select Attachment Types"
		 subTitle="Rule will be triggered if at least one of the selected attachment types is found in the email's attached files"
		 width="700px" height="auto"
		 (closeCb)="attachmentTypesPopup = null"
		 (confirmCb)="applyAttachmentTypesPopup();"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">

	<div class="flex-column f-1-0 vSpace2 danger-message">
		<div class="flex-column f-1-0 gap-2 position-relative" style="overflow: auto;">
			<div class="position-absolute" style="top: 10px; z-index: 10; left: 10px;">
				<checkbox id="aiiAttachmentTypes" [(model)]="attachmentTypesPopup.all_types">
					All attachment types
				</checkbox>
			</div>
			<div *ngIf="attachmentTypesPopup.all_types" class="d-flex centralize w-100 position-absolute" style="top: 0; min-height: 500px; height: 100%; z-index: 9; font-weight: bold; background-color: #ffffffbf;">
				<span>all attachment types are enabled</span>
			</div>
			<trustifi-table-c
				class="trustifi-table" style="min-height: 500px; flex: 1 0; overflow: auto; z-index: 5; background: #fdfdfd; padding: 5px;"
				[list]="attachmentTypesPopup.fileTypesList"
				[headers]="[
					{text:'Name', sortKey:'display', width: '45%'},
					{text:'Extension', width: '55%'},
				]"
				[cellsPrototype]="[
					{textKey: 'display'},
					{html: 'typeCell'},
				]"
				(searchFunction)="searchAttachmentTypes($event.searchTerm, $event.activeFilters)"
				[options]="{
					itemUniqueIdentifier: 'display',
					itemsNameSingular: 'file type',
					showRadioButtons: true,
				}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<!--action cells-->
					<div *ngIf="cellId === 'typeCell'">
					<span style="text-overflow: unset; white-space: normal;">
						{{item.extension ? item.extension.join(', ') : ''}}
					</span>
					</div>
				</ng-template>
			</trustifi-table-c>
		</div>
	</div>
</popup-c>

<!--sender country tld popup-->
<popup-c *ngIf="senderCountryTldPopup?.show"
		 head="Sender Country TLD"
		 size="medium"
		 (closeCb)="senderCountryTldPopup.show = false"
		 (confirmCb)="applySenderCountryTldPopup();"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">

	<div class="flxClmn f-1-0" style="overflow: auto;">
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="senderCountryTldPopup.senderCountryTlds"
			[headers]="[
				{text:'TLD', sortKey:'tld'},
				{text:'Country', sortKey: 'desc'},
			]"
			[cellsPrototype]="[
				{textKey: 'tld'},
				{textKey: 'desc'},
			]"
			[options]="{
				showRadioButtons: true
			}"
			(searchFunction)="searchSenderCountryTld($event.searchTerm, $event.activeFilters)"
		>
			<!---->
		</trustifi-table-c>
	</div>
</popup-c>

<!--email language popup-->
<popup-c *ngIf="emailLanguagePopup?.show"
		 head="Email Language"
		 size="medium"
		 (closeCb)="emailLanguagePopup.show = false"
		 (confirmCb)="applyEmailLanguagePopup();"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">

	<div class="flxClmn f-1-0" style="overflow: auto;">
		<span class="text-muted" style="margin-bottom: 8px;">Detected from the email subject and body. Emails too short to tell count as English. Arabic script also covers Persian and Urdu.</span>
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="emailLanguagePopup.emailLanguages"
			[headers]="[
				{text:'Language', sortKey:'desc'},
				{text:'Code', sortKey: 'code'},
			]"
			[cellsPrototype]="[
				{textKey: 'desc'},
				{textKey: 'code'},
			]"
			[options]="{
				showRadioButtons: true
			}"
			(searchFunction)="searchEmailLanguage($event.searchTerm, $event.activeFilters)"
		>
			<!---->
		</trustifi-table-c>
	</div>
</popup-c>

<!--email scan sub status popup-->
<popup-c *ngIf="emailScanSubStatusPopup?.show"
		 head="Email Scan Sub Category"
		 size="large"
		 (closeCb)="emailScanSubStatusPopup.show = false"
		 (confirmCb)="applyEmailScanSubStatusPopup();"
		 [buttons]="{cancel: 'Cancel', confirm: 'Confirm'}">

	<div class="flxClmn f-1-0" style="overflow: auto;">
		<trustifi-table-c
			#subCategoriesTable
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="emailScanSubStatusPopup.tpMetrics"
			[headers]="[
				{text: 'Sub Category', sortKey: 'sub_status', width: '280px'},
				{text: 'Category', sortKey: 'status', width: '110px'},
				{text: 'Description', sortKey: 'description'},
			]"
			[cellsPrototype]="[
				{textKey: 'sub_status'},
				{textKey: 'status'},
				{html: 'descCell'},
			]"
			[options]="{
				showRadioButtons: true,
				itemUniqueIdentifier: 'sub_status'
			}"
			(searchFunction)="searchScanSubStatus($event.searchTerm, $event.activeFilters)"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<span style="text-overflow: unset; white-space: normal;" *ngIf="cellId === 'descCell'">
					{{item.description}}
				</span>
			</ng-template>
		</trustifi-table-c>
		<div class="flex-row flex-wrap px-2 pt-3 flex-shrink-0 justify-content-start gap-2 align-items-baseline overflow-auto" style="height: 86px;">
			<span *ngFor="let subCategory of _.filter(emailScanSubStatusPopup.tpMetrics, 'selected') | unique:'sub_status'"
				  class="p-1 d-flex gap-2 align-items-center rounded-1 bg-dark"
				  (click)="subCategory.selected = false; subCategoriesTable.filterSelectedItems();"
				  style="cursor: pointer; --bs-bg-opacity: .07;">
				{{subCategory.sub_status}} <i class="zmdi zmdi-close"></i>
			</span>
		</div>
	</div>
</popup-c>

<sensitivity-type-c
	*ngIf="modalData?.openSensitivityTypesPopup"
	[data]="modalData"
	[allTypes]="sensitivity_types"
	[doNotDeleteTypes]="[]"
	[hideAddTypesBtn]="true"
	[selectedTypes]="conditionInEdit.data.sensitivity_types"
	(updateCb)="updateTypes($event.types, $event.newTypes)"
	(cancelCb)="cancelSensitivityTypesPopup()">
</sensitivity-type-c>

<groups-popup-c
	*ngIf="showRuleGroups"
	(cancelCb)="showRuleGroups = false"
	(doneCb)="applyGroupsPopup($event.groups)"
	[doneBtnTxt]="'Apply'"
	[selectedGroups]="selectedGroupsRule"
	[multipleSelection]="true"
	[popupTitle]="'Select Groups'"
	[popupSubTitle]="'The rule will be applied according to the selected groups'">
</groups-popup-c>

<users-selection-component style="display: contents;"
						   *ngIf="usersSelectionPopup?.show"
						   [data]="usersSelectionPopup"
						   [selectedUsers]="usersSelectionPopup.selectedUsers"
						   (addCb)="startAddFromUsersSelection($event.users)"
						   (removeCb)="startRemoveFromUsersSelection($event.users)">
</users-selection-component>
